export const downloadFile = (objectUrl: string, fileName?: string) => {
  const link = window.document.createElement("a");
  fileName && (link.download = fileName);
  link.href = objectUrl;
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const downloadBlob = (blob: Blob, fileName?: string) => {
  downloadFile(URL.createObjectURL(blob), fileName);
};

// strips characters that are unsafe in OS file names
export const sanitizeFileName = (name: string) =>
  name
    .trim()
    .replace(/[/\\?%*:|"<>]/g, "-")
    .replace(/^-+|-+$/g, "")
    .trim();
